/* tslint:disable */

/**
 */
export class PermissionForm_v2 {
    role_id?: number;
    company_id?: number;
    permission_data?: string;
}
